import { render, staticRenderFns } from "./UploadConfig.vue?vue&type=template&id=74b248a4&scoped=true"
import script from "./UploadConfig.vue?vue&type=script&lang=js"
export * from "./UploadConfig.vue?vue&type=script&lang=js"
import style0 from "./UploadConfig.vue?vue&type=style&index=0&id=74b248a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b248a4",
  null
  
)

export default component.exports